module.exports = __webpack_public_path__ + "static/media/simonGame.3c9a9a4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/simonGame.jpg
// module id = 81
// module chunks = 0